import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=87b668c6&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=87b668c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b668c6",
  null
  
)

export default component.exports